import type { MediaEntry } from '../api/schema.js'
import { clamp } from './math.js'

/**
 * 디자인 툴의 프레이밍 값을 CSS object-position으로 환산한다.
 *
 * 원본은 이미지를 translate(-50%,-50%)로 중앙에 두고 y를 프레임 높이의 백분율만큼
 * 아래로 민다. object-position에서 50%가 중앙이고 0%가 위쪽 정렬이므로,
 * 오버플로우 대비 비율만큼 50에서 빼면 같은 크롭이 된다.
 */
export function objectPositionY(
  imgWidth: number,
  imgHeight: number,
  frameAspect: number,
  yPercent: number,
): number {
  if (imgWidth <= 0 || imgHeight <= 0) return 50
  const imgAspect = imgWidth / imgHeight
  // 이미지가 프레임보다 가로로 넓으면 높이가 딱 맞아 세로 오버플로우가 없다.
  if (imgAspect >= frameAspect) return 50
  const overflowRatio = frameAspect / imgAspect - 1
  if (overflowRatio <= 0) return 50
  return clamp(50 - yPercent / overflowRatio, 0, 100)
}

export function objectPositionFor(entry: MediaEntry, frameAspect: number): string {
  const y = entry.framing?.y
  if (y === undefined || entry.width === undefined || entry.height === undefined) return '50% 50%'
  return `50% ${objectPositionY(entry.width, entry.height, frameAspect, y).toFixed(2)}%`
}

/** 세로 사진만 두 장씩 나란히 배치하고 프레임은 실제 사진의 비율을 따른다. */
export function galleryTileSpan(
  { width, height }: Pick<MediaEntry, 'width' | 'height'>,
): { span: string; aspect: string } {
  if (width === undefined || height === undefined
    || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    // 디코딩 전에도 실패한 사진의 액자가 사라지지 않도록 자리를 예약한다.
    return { span: '1 / -1', aspect: '1/1' }
  }
  return { span: width < height ? 'auto' : '1 / -1', aspect: `${width}/${height}` }
}
